var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "menu-screen",
      style: { backgroundColor: _vm.theme.screenBackgroundColor.value },
    },
    [
      _c(
        "header",
        {
          staticClass: "header",
          style: { backgroundColor: _vm.theme.headerBackgroundColor.value },
        },
        [
          _c(
            "h1",
            {
              staticClass: "header-title",
              style: { color: _vm.theme.headerTextColor.value },
            },
            [_vm._v("Menu")]
          ),
        ]
      ),
      _c("div", { staticClass: "meta-section" }, [
        _c("h2", { style: { color: _vm.theme.PrimaryTextColor.value } }, [
          _vm._v("1st Pickup Location(Bar)"),
        ]),
        _c("p", { style: { color: _vm.theme.SecondaryTextColor.value } }, [
          _vm._v("Come to the front for pickup"),
        ]),
        _c(
          "div",
          {
            staticClass: "pill",
            style: {
              backgroundColor: _vm.theme.accentBackgroundColor.value,
              color: _vm.theme.accentTextColor.value,
            },
          },
          [_vm._v(" Estimated Time: 2-4 Minutes ")]
        ),
      ]),
      _c("div", { staticClass: "category" }, [
        _c(
          "h2",
          {
            staticClass: "category-title",
            style: {
              color: _vm.theme.PrimaryTextColor.value,
              borderTop: "2px solid " + _vm.theme.borderColor.value,
            },
          },
          [_vm._v("Cocktails")]
        ),
        _c(
          "div",
          {
            staticClass: "item-row",
            style: { borderBottom: "1px solid " + _vm.theme.borderColor.value },
          },
          [
            _c("div", { staticClass: "item-text" }, [
              _c(
                "h5",
                { style: { color: _vm.theme.altTextHeaderColor.value } },
                [_vm._v("Vodka Cranberry")]
              ),
              _c("p", { style: { color: _vm.theme.PrimaryTextColor.value } }, [
                _vm._v("$1.00"),
              ]),
              _c(
                "p",
                { style: { color: _vm.theme.SecondaryTextColor.value } },
                [_vm._v("A classic")]
              ),
            ]),
            _c("img", {
              staticClass: "item-img",
              attrs: { src: require("@/assets/vodka cranberry.jpg") },
            }),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "item-row",
            style: { borderBottom: "1px solid " + _vm.theme.borderColor.value },
          },
          [
            _c("div", { staticClass: "item-text" }, [
              _c(
                "h5",
                { style: { color: _vm.theme.altTextHeaderColor.value } },
                [_vm._v("Margharita")]
              ),
              _c("p", { style: { color: _vm.theme.PrimaryTextColor.value } }, [
                _vm._v("$1.00"),
              ]),
              _c(
                "p",
                { style: { color: _vm.theme.SecondaryTextColor.value } },
                [_vm._v("A classic")]
              ),
            ]),
            _c("img", {
              staticClass: "item-img",
              attrs: { src: require("@/assets/Margharita.jpg") },
            }),
          ]
        ),
        _c("div", { staticClass: "item-row" }, [
          _c("div", { staticClass: "item-text" }, [
            _c("h5", { style: { color: _vm.theme.altTextHeaderColor.value } }, [
              _vm._v("Rum Punch"),
            ]),
            _c("p", { style: { color: _vm.theme.PrimaryTextColor.value } }, [
              _vm._v("$1.00"),
            ]),
            _c("p", { style: { color: _vm.theme.SecondaryTextColor.value } }),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "category" }, [
        _c(
          "h2",
          {
            staticClass: "category-title",
            style: {
              color: _vm.theme.PrimaryTextColor.value,
              borderTop: "2px solid " + _vm.theme.borderColor.value,
            },
          },
          [_vm._v("Wine")]
        ),
        _c(
          "div",
          {
            staticClass: "item-row",
            style: { borderBottom: "1px solid " + _vm.theme.borderColor.value },
          },
          [
            _c("div", { staticClass: "item-text" }, [
              _c(
                "h5",
                { style: { color: _vm.theme.altTextHeaderColor.value } },
                [_vm._v("Red Wine")]
              ),
              _c("p", { style: { color: _vm.theme.PrimaryTextColor.value } }, [
                _vm._v("$1.00"),
              ]),
            ]),
            _c("img", {
              staticClass: "item-img",
              attrs: { src: require("@/assets/vodka cranberry.jpg") },
            }),
          ]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "view-cart",
          style: {
            backgroundColor: _vm.theme.submitButtonColor.value,
            color: _vm.theme.submitButtonTextColor.value,
          },
        },
        [_vm._v(" View Cart(1) ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }